var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9444_3147",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9444_3147)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 12.75H10.25V8.25H8.75V12.75ZM9.5 6.75C9.7125 6.75 9.89063 6.67812 10.0344 6.53438C10.1781 6.39062 10.25 6.2125 10.25 6C10.25 5.7875 10.1781 5.60938 10.0344 5.46562C9.89063 5.32187 9.7125 5.25 9.5 5.25C9.2875 5.25 9.10938 5.32187 8.96563 5.46562C8.82188 5.60938 8.75 5.7875 8.75 6C8.75 6.2125 8.82188 6.39062 8.96563 6.53438C9.10938 6.67812 9.2875 6.75 9.5 6.75ZM9.5 16.5C8.4625 16.5 7.4875 16.3031 6.575 15.9094C5.6625 15.5156 4.86875 14.9813 4.19375 14.3063C3.51875 13.6313 2.98438 12.8375 2.59063 11.925C2.19687 11.0125 2 10.0375 2 9C2 7.9625 2.19687 6.9875 2.59063 6.075C2.98438 5.1625 3.51875 4.36875 4.19375 3.69375C4.86875 3.01875 5.6625 2.48438 6.575 2.09063C7.4875 1.69687 8.4625 1.5 9.5 1.5C10.5375 1.5 11.5125 1.69687 12.425 2.09063C13.3375 2.48438 14.1313 3.01875 14.8063 3.69375C15.4813 4.36875 16.0156 5.1625 16.4094 6.075C16.8031 6.9875 17 7.9625 17 9C17 10.0375 16.8031 11.0125 16.4094 11.925C16.0156 12.8375 15.4813 13.6313 14.8063 14.3063C14.1313 14.9813 13.3375 15.5156 12.425 15.9094C11.5125 16.3031 10.5375 16.5 9.5 16.5ZM9.5 15C11.175 15 12.5938 14.4187 13.7563 13.2563C14.9187 12.0938 15.5 10.675 15.5 9C15.5 7.325 14.9187 5.90625 13.7563 4.74375C12.5938 3.58125 11.175 3 9.5 3C7.825 3 6.40625 3.58125 5.24375 4.74375C4.08125 5.90625 3.5 7.325 3.5 9C3.5 10.675 4.08125 12.0938 5.24375 13.2563C6.40625 14.4187 7.825 15 9.5 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSendIcon);
export default __webpack_public_path__ + "static/media/link_send_icon.d49bca78236496eba0570d0f1ea247de.svg";
export { ForwardRef as ReactComponent };